import React, { useState, useEffect } from 'react';
import './ImageCarousel.css';  // We'll add styling here
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";

const ImageCarousel = ({ images, onSelect, onOpen }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  const nextImageKeyDown = (event) => {
    if (event.key === 'ArrowRight') {
      nextImage();
    } else if (event.key === 'ArrowLeft') {
      prevImage();
    }
  }

  useEffect(() => {
    onSelect(currentIndex);
  }, [currentIndex]);

  return (
    <div className="carousel-container" onKeyDown={nextImageKeyDown}>
      <button className="carousel-btn prev-btn" onClick={prevImage}>
        <FaAngleLeft className="carousel-icon" />
      </button>

      <div className="carousel-images" onClick={onOpen}>
        <img
          src={images[currentIndex]}
          alt="carousel"
          className="carousel-image"
        />
      </div>

      <button className="carousel-btn next-btn" onClick={nextImage}>
        <FaAngleRight className="carousel-icon" />
      </button>
    </div>
  );
};

export default ImageCarousel;
